module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/chevron_down-612d64b1af3b9a562d4f355601f2c863.svg";